/* OGR Frame Messaging
 * setzen der Höhe und der scroll-Position via postMessage
 *
 * die initiale Höhe wird automatisch ausgelesen
 * später kann "ogrFrameMsg.send()" aufgerufen werden um nachträglich die Höhe anzupassen.
 *
 * Bsp. setzen einer Höhe in Pixel: ogrFrameMsg.send(200, false);
 * Bsp. setzen einer Scrollposition: ogrFrameMsg.send(false, 100);
 * Bsp. setzen einer Höhe und Scrollposition: ogrFrameMsg.send(200, 100);
 *
 * jQuery muss vorher geladen und verfügbar sein
 */

var ogrFrameMsg = (function ($)
{
	var eventMethod  = window.addEventListener ? "addEventListener" : "attachEvent",
		eventer      = window[eventMethod],
		messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message",
		is_ready     = false,
		id,
		source,
		origin,
		current_height;
	
	// auf postMessage-Anfragen hören
	eventer(messageEvent, function (event)
	{
		// Daten-String, welcher von der webCenter-Seite gesendet wird, z.b. "height-2"
		var data = event.data;
		
		// falls keine Daten gesendet wurde abbrechen
		if (!data || data.length === 0)
		{
			return;
		}
		
		// Daten in ein Array konvertieren
		data = data.split('-');
		
		// das Array hat immer zwei Einträge
		if (data.length !== 2)
		{
			return;
		}
		
		// der erste Wert ist immer "height", falls nicht abbrechen
		if (data[0] !== 'height')
		{
			return;
		}
		
		// der zweite Wert ist immer numerisch, falls nicht, abbrechen
		// dies ist der Wert, mit dem wir den iframe identifizieren können
		id = parseInt(data[1], 10);
		if (isNaN(id))
		{
			id = undefined;
			return;
		}
		
		// Quelle speichern für spätere andragen
		source = event.source;
		origin = event.origin;
		
		// alles richtig initiiert
		is_ready = true;
		
		// aktuelle initiale Höhe als String zur webCenter-Seite senden
		sendPostMessage($('body').height(), false);
	}, false);
	
	// Format: id-höhe-scrollposition z.b. 2-300-0
	function sendPostMessage(height, scroll)
	{
		if (!is_ready)
		{
			return;
		}
		
		// aktuelle höhe speichern
		if (typeof height === 'number')
		{
			current_height = height;
		}
		
		// string zusammensetzen
		var sendString = id + '-' + current_height;
		
		if (typeof scroll === 'number')
		{
			sendString += '-' + scroll
		}
		
		source.postMessage(sendString, origin);
	};
	
	return {
		send: function (height, scroll)
			  {
				  sendPostMessage(height, scroll);
			  }
	}
})(jQuery);